Vue.component('ppcarto-list', {

  template: `
  <div v-bind:class="['ppcarto-list',activesection ? activesection.key : '' ]" v-show="show">
    <header>
      <h2>{{ activesection ? activesection.name : '' }}</h2>
    </header>
    <div class="ppcarto-list-wrapper">
      <ppcarto-card v-for="item in items" :item="item" :settings="settings" :section="activesection"></ppcarto-card>
      <div style="flex: 1 100%;"><infinite-loading :on-infinite="onInfinite" ref="infiniteLoading" :distance="distance" :spinner="spinner">
      <span slot="no-more"></span>
      <div slot="no-results" class="no-result">
        <p>keine Ergebnisse in diesem Kartenabschnitt.</p>
        <p><strong>Karte verschieben oder Zoom verändern</strong></p>
      </div>
      </infinite-loading></div>
    </div>      
  </div>
  `,
  data() {
    return {
      settings: ppcarto.settings,
      distance: 100,
      spinner: "waveDots",
      items: [],
      bbox: "",
      page: 1,
      query: null,
      //activesection:{}
    };
  },
  computed: {
    boundingBox() {
      return this.$store.getters.getBoundingBox
    },
    selectedSections() {
      return this.$store.getters.selectedSections
    },
    activesection() {
      let sections = this.$store.getters.selectedSections;
      let last = _.last(this.$store.getters.getHistory);

      if (!last || !sections) {
        return;
      }

      let section = _.find(sections, s => { return s.key == last.key })
      return section;


    },
    activeCategories() {
      return this.$store.getters.activeCategories
    },
    show() {
      return this.activesection && this.query && !this.showMap;
    },
    showMap(){
      return this.$store.getters.showMap;
    }

  },

  watch: {
    boundingBox(bbox) {
      this.bbox = bbox.toBBoxString();
      this.page = 1;
      this.items = [];
      this.$nextTick(() => {
        this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
      });
    },

    query() {
      this.page = 1;
      this.items = [];
      this.$nextTick(() => {
        this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
      });
    },

    //  selectedSections(newSections, oldSections) {
    //    if(newSections) {
    //      this.activesection = _.last(newSections);
    //    }
    //  },
    activeCategories(newCategories, oldCategories) {
      let section = this.activesection;
      let categories = [];

      if (section) {
        categories = _.filter(section.categories, c => c.active)
      }

      if(section && categories.length > 0) {
        
        if (categories.length > 0) {
          this.query = {
            categories: {
              or: _.map(categories, c => { return { category: c.id } })
            }
          }
        }
      } else {
        this.items = [];
        this.page = 1;
        this.query = null;
      }

    },
    showMap(){
      this.$nextTick(() => {
        this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
      });
    }
  },

  methods: {
    onInfinite() {
      if (this.query != null) {
        let params = { bbox: this.bbox, page: this.page };
        _.merge(params, this.query);

        this.$http.post(`${this.settings.api.baseurl}${this.settings.api.endpoints[this.activesection.key].url}?limit=24`, params).then((response) => {
          if (response.data[this.settings.api.endpoints[this.activesection.key].key].length > 0) {
            this.items = this.items.concat(response.data[this.settings.api.endpoints[this.activesection.key].key]);
            this.page = response.data.meta.page + 1;
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');
            if (response.data.meta.page == response.data.meta.total_pages) {
              this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
              this.page = 1;
            }
          } else {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
            this.page = 1;
          }

        });
      }

    },
  }

});
